import React from "react";
import { legalCss, SiteNav, SiteFooter, LegalPreloader } from "../components/LegalChrome";

const Conditii = () => {
  return (
    <div className="lg-root">
      <style>{legalCss}</style>
      <LegalPreloader />
      <div className="lg-grain" />

      <SiteNav />

      <section className="lg-hero">
        <div className="lg-label">Aware</div>
        <h1>Termeni și Condiții</h1>
        <div className="lg-updated">Ultima actualizare: 3 septembrie 2026</div>
      </section>

      <div className="lg-body">
        <p className="lg-intro">
          Bine ați venit pe awaretherapycenter.ro, operat de{" "}
          <strong>Antonescu și Asociații — Societate Civilă Profesională de Psihologie</strong>,
          CUI 42449928, Constanța ("Aware", "noi"). Folosind site-ul, sunteți de acord cu termenii de mai jos.
        </p>

        <div className="lg-sec">
          <div className="lg-sec-num">01</div>
          <h2>Despre acest site</h2>
          <p>
            Prezentăm centrul Aware, echipa de psihologi, serviciile și evenimentele. Conținutul are
            caracter general și nu înlocuiește o discuție directă cu un specialist.
          </p>
        </div>

        <div className="lg-sec">
          <div className="lg-sec-num">02</div>
          <h2>Programări</h2>
          <p>
            <strong>Nu se fac prin site.</strong> Ne contactați telefonic sau prin email, cu datele
            afișate pe site.
          </p>
        </div>

        <div className="lg-sec">
          <div className="lg-sec-num">03</div>
          <h2>Conturi de utilizator</h2>
          <p>Opționale — folosite, printre altele, pentru newsletter, pe bază de consimțământ.</p>
        </div>

        <div className="lg-sec">
          <div className="lg-sec-num">04</div>
          <h2>Proprietate intelectuală</h2>
          <p>Textele, design-ul și fotografiile echipei de pe acest site nu pot fi reproduse ca atare, pe alte site-uri, fără acordul nostru.</p>
        </div>

        <div className="lg-sec">
          <div className="lg-sec-num">05</div>
          <h2>Răspundere și modificări</h2>
          <p>
            Nu răspundem pentru decizii luate exclusiv pe baza informațiilor de pe site, fără o
            discuție directă cu un specialist. Putem actualiza periodic acești termeni; data de mai sus
            arată ultima actualizare. Termenii sunt guvernați de legislația română.
          </p>
        </div>

        <div className="lg-contact-box">
          <p><strong>Pentru orice întrebare:</strong></p>
          <p>Email: <a href="mailto:psihologie.aware@gmail.com">psihologie.aware@gmail.com</a></p>
          <p>Telefon: <a href="tel:+40723071922">+40 723 071 922</a></p>
        </div>
      </div>

      <SiteFooter />
    </div>
  );
};

export default Conditii;
